/**
 * The type of (redux) action which signals that the controller is capturing mouse and keyboard events.
 *
 * {
 *     type: CAPTURE_EVENTS,
 *     isCapturingEvents: boolean
 * }
 */
export const CAPTURE_SIGNATURE_EVENTS = 'CAPTURE_SIGNATURE_EVENTS';
/**
 * The type of (redux) action which signals that a remote control active state has changed.
 *
 * {
 *     type: REMOTE_CONTROL_SIGNATURE_ACTIVE,
 *     active: boolean
 * }
 */
export const SIGNATURE_ACTIVE = 'SIGNATURE_ACTIVE';
/**
 * The type of (redux) action which sets the receiver transport object.
 *
 * {
 *     type: SET_RECEIVER_SIGNATURE_TRANSPORT,
 *     transport: Transport
 * }
 */
export const SET_RECEIVER_SIGNATURE_TRANSPORT = 'SET_RECEIVER_SIGNATURE_TRANSPORT';
/**
 * The type of (redux) action which enables the receiver.
 *
 * {
 *     type: SET_RECEIVER_SIGNATURE_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_RECEIVER_SIGNATURE_ENABLED = 'SET_RECEIVER_SIGNATURE_ENABLED';
/**
 * The type of (redux) action which sets the controller participant on the receiver side.
 * {
 *     type: SET_SIGNATURE_CONTROLLER,
 *     controller: string
 * }
 */
export const SET_SIGNATURE_CONTROLLER = 'SET_SIGNATURE_CONTROLLER';
/**
 * The type of (redux) action which sets the controlled participant on the controller side.
 * {
 *     type: SET_CONTROLLED_SIGNATURE_PARTICIPANT,
 *     controlled: string
 * }
 */
export const SET_CONTROLLED_SIGNATURE_PARTICIPANT = 'SET_CONTROLLED_SIGNATURE_PARTICIPANT';
/**
 * The type of (redux) action which sets the requested participant on the controller side.
 * {
 *     type: SET_REQUESTED_SIGNATURE_PARTICIPANT,
 *     requestedParticipant: string
 * }
 */
export const SET_REQUESTED_SIGNATURE_PARTICIPANT = 'SET_REQUESTED_SIGNATURE_PARTICIPANT';
